module.exports = __webpack_public_path__ + "static/fonts/fontello.33bcc95.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/vue-goodshare/src/fonts/fontello.ttf?88483298
// module id = 495
// module chunks = 14 15